export const GROUP = '/group/'
export const GROUP_ALL = `${GROUP}all`
export const GROUP_ASSIGN = `${GROUP}assign`
export const GROUP_GROUPING = `${GROUP}grouping`
export const GROUP_SHUFFLE = `${GROUP}shuffle`
export const GROUP_STUDENT_TRANSFER = `${GROUP}student/transfer`
